import { render, staticRenderFns } from "./BillForm.vue?vue&type=template&id=56afc66e&"
import script from "./BillForm.vue?vue&type=script&lang=ts&"
export * from "./BillForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports